import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CollapseStyles } from './models/collapse-classes.model';

@Component({
  selector: 'collapse',
  templateUrl: 'collapse.component.html',
  styleUrls: ['collapse.component.scss'],
  animations: [
    trigger('inOutAnimation', [
      state('*', style({ 'overflow-y': 'hidden' })),
      state('void', style({ 'overflow-y': 'hidden' })),
      transition('* => void', [
        style({ height: '*' }),
        animate('{{time}}ms', style({ height: 0 }))
      ]),
      transition('void => *', [
        style({ height: '0' }),
        animate('{{time}}ms', style({ height: '*' }))
      ])
    ])
  ],
})
export class CollapseComponent {

    @Input() public showContent: boolean = false;
    @Input() public forceShowContent: boolean = false;
    @Output() public showContentChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() public styles?: CollapseStyles;
    @Input() public hideButton = false;

    public toggleCollapsible(): void {
      this.showContent = !this.showContent;
      this.showContentChange.emit(this.showContent);
    }

}
